import cache from 'lscache';

export interface ILocalCache {
    /**
     * Stores the value in localStorage. Expires after specified number of minutes.
     * @param {string} key
     * @param {Object|string} value
     * @param {number} time
     * @return true if the value was inserted successfully
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    set(key: string, value: any, time?: number): boolean;
    /**
     * Retrieves specified value from localStorage, if not expired.
     * @param {string} key
     * @return {string|Object}
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(key: string): any;
    /**
     * Removes a value from localStorage.
     * Equivalent to 'delete' in memcache, but that's a keyword in JS.
     * @param {string} key
     */
    remove(key: string): void;
}

export class LSCache implements ILocalCache {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    set = (key: string, value: any, time?: number): boolean => {
        return cache.set(key, value, time);
    };

    get = (key: string) => {
        return cache.get(key);
    };

    remove = (key: string) => {
        cache.remove(key);
    };
}
export default new LSCache();
